<template>
  <BaseModal :value="true" id="create-coupon-modal" @input="$emit('close')">
    <template #header>
      <h2 class="text-lg font-semibold">New coupon</h2>
    </template>
    <div class="p-2">
      <CouponForm
        :saving="saving"
        v-model="newEntry"
        @confirm="create()"
        @discard="$emit('close')"
        :create="true"
      />
    </div>
  </BaseModal>
</template>
<script>
import { createCoupon } from "@/api/store/CouponsService.js";
import CouponForm from "./CouponForm.vue";
import { localToday } from "./couponLabels.js";
export default {
  name: "CreateCoupon",
  components: {
    CouponForm
  },
  data() {
    return {
      saving: false,
      response: null,
      newEntry: {
        code: "",
        fromDate: "",
        toDate: "",
        minAmount: 0,
        maxAmount: 0,
        discountType: "",
        amount: 0,
        freeShippingType: 0,
        usesLimit: 0,
        usesLimitUser: 0,
        freeShipping: "",
        status: 1,
        products: []
      }
    };
  },
  methods: {
    async create() {
      this.response = null;
      this.saving = true;
      try {
        const res = await createCoupon(this.newEntry);
        this.saving = false;
        if (res) {
          this.$toast.success("Coupon created successfully");
          this.$emit("created", { ...this.newEntry, id: res.coupon });
        } else {
          this.$toast.error("Error creating coupon");
        }
      } catch (e) {
        this.response = e.response ? e.response.data : null;
        this.$toast.error(this.response ? this.response : e.message);
        this.saving = false;
        return;
      }
    }
  },
  mounted() {
    this.newEntry.fromDate = localToday();
    this.newEntry.toDate = localToday();
    this.$nextTick(() => {
      const codeField = document.querySelector("#create-coupon-modal #code input");
      if (codeField) codeField.focus();
    });
  }
};
</script>
<style>
#create-coupon-modal .modal-content {
  max-width: 760px;
}
</style>
<style scoped></style>
